// 배너, 아이템, 태그 등등
import { apiClient } from "./axios";

const bannerList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/banner/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const bannerUpdate = async ({
  bannerUrl,
  bannerLocation,
  banner,
  bannerId,
  bannerPosition,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/banner/update", {
      banner_id: bannerId,
      banner_image: banner,
      banner_location: bannerLocation,
      banner_link: bannerUrl,
      banner_position: bannerPosition,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const bannerDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/banner/delete", {
      banner_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const bannerCreate = async ({
  bannerUrl,
  bannerLocation,
  bannerLink,
  bannerPosition,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/banner/crate", {
      banner_url: bannerUrl,
      banner_location: bannerLocation,
      banner_link: bannerLink,
      banner_position: 1,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/product/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    console.log(res.data);
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productCreate = async ({
  productThumbnail,
  productTitle,
  productPrice,
  productLink,
  brandName,
  contentId,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/crate", {
      product_thumbnail: productThumbnail,
      product_title: productTitle,
      product_price: productPrice,
      product_link: productLink,
      brand_name: brandName,
      content_id: contentId,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productUpdate = async ({
  productThumbnail,
  productTitle,
  productPrice,
  productLink,
  brandName,
  contentId,
  id,
  exposure,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/update", {
      product_thumbnail: productThumbnail,
      product_title: productTitle,
      product_price: productPrice,
      product_link: productLink,
      brand_name: brandName,
      content_id: contentId,
      id: id,
      exposure: exposure,
    });
    console.log("update", res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/delete", {
      id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/tag/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagCreate = async ({ tags }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/tag/create", {
      tag_name: tags.tag_name,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/tag/delete", {
      tag_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const globalIndicators = async () => {
  try {
    const res = await apiClient.get("/api/v1/admin/traffic");
    if (!res.data.traffic.status) {
      console.error(res.data.traffic.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const servayList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/user/servay/list`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const servayResultList = async ({user_id,servay_id}) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/user/servay?user_id=${user_id}&servay_id=${servay_id}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const subItemHooks = {
  globalIndicators,
  bannerList,
  bannerUpdate,
  bannerDelete,
  bannerCreate,
  productList,
  productCreate,
  productUpdate,
  productDelete,
  tagList,
  tagCreate,
  tagDelete,
  servayList,
  servayResultList
};

export default subItemHooks;
